
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select"; // @ref https://sagalbot.github.io/vue-select/

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class EditActionPlan extends Vue {
	// validation
	public isUserGroupValid: boolean = true;
	public isActionPlanTitleValid: boolean = true;
	public get hasValidationErrors() {
		if (this.actionPlan.title) {
			this.isActionPlanTitleValid = true;
			return false;
		} else {
			this.isActionPlanTitleValid = false;
			return true;
		}
	}
	public showErrorAnimation: boolean = false;

	public userGroupSelectPlaceholder: any = {};

	@Prop({
		default: () => ({
			title: {
				type: String,
				required: true
			},
			groupID: {
				type: Number,
				required: true
			}
		})
	})
	actionPlan!: any; // @todo type

	public mounted() {
		//// when adding a new action plan
		//if (!this.actionPlan['groupID']) {
		//    this.userGroupSelectPlaceholder = this.userGroups[0];
		//} else {
		//    this.userGroupSelectPlaceholder = this.userGroups.filter(
		//        g => g.groupID === this.actionPlan.groupID
		//)[0];
		//}
	}

	@Prop(Array)
	userGroups!: any[]; // @todo group type

	@Watch("userGroupSelectPlaceholder", { immediate: true, deep: true })
	onTaskUserGroupChanged(userGroup: any) {
		if (!userGroup["groupID"]) {
			// previosuly selected group deselected
			this.isUserGroupValid = false;
		} else {
			this.actionPlan.groupID = userGroup.groupID;
			this.isUserGroupValid = true;
		}
	}

	public onSave() {
		if (!this.hasValidationErrors) {
			this.$emit("save", this.actionPlan);
		} else {
			this.showErrorAnimation = true;
			setTimeout(() => {
				this.showErrorAnimation = false;
			}, this.$config.ANIMATION_DURATION);
		}
	}

	public onCancel() {
		this.$emit("cancel");
	}
}
